import { RequestState } from '@modules/registration/omc-registration/store/omc-registration.action';
import { createReducer, on } from '@ngrx/store';
import * as AgentTypesActions from './agent-types.actions';
import { handleFailure, handleRequest, handleSuccess } from '@shared/ngrx-factory/factory.reducer';
import { AgentType, PaginatedAgentTypes } from '../responses/agent-types.response';

export interface AgentTypesState {
  agentTypes: RequestState<PaginatedAgentTypes>;
  saveAgentType: RequestState<AgentType>;
  deleteAgentType: RequestState<any>;
  selectedAgentType: RequestState<AgentType>;
}

export const initialAgentTypesState: AgentTypesState = {
  agentTypes: { loading: false, message: null, response: null, error: null },
  saveAgentType: { loading: false, message: null, response: null, error: null },
  deleteAgentType: { loading: false, message: null, response: null, error: null },
  selectedAgentType: { loading: false, message: null, response: null, error: null },
};

export const agentTypesReducer = createReducer(
  initialAgentTypesState,

  // Fetch paginated
  on(AgentTypesActions.AgentTypesAction.request, (state) =>
    handleRequest(state, 'agentTypes'),
  ),
  on(AgentTypesActions.AgentTypesAction.success, (state, { response }) =>
    handleSuccess(state, 'agentTypes', response.data),
  ),
  on(AgentTypesActions.AgentTypesAction.failure, (state, { error }) =>
    handleFailure(state, 'agentTypes', error),
  ),

  // Save (Create / Update)
  on(AgentTypesActions.SaveAgentTypeAction.request, (state) =>
    handleRequest(state, 'saveAgentType'),
  ),
  on(AgentTypesActions.SaveAgentTypeAction.success, (state, { response }) =>
    handleSuccess(state, 'saveAgentType', response.data),
  ),
  on(AgentTypesActions.SaveAgentTypeAction.failure, (state, { error }) =>
    handleFailure(state, 'saveAgentType', error),
  ),

  // Delete
  on(AgentTypesActions.DeleteAgentTypeAction.request, (state) =>
    handleRequest(state, 'deleteAgentType'),
  ),
  on(AgentTypesActions.DeleteAgentTypeAction.success, (state, { response }) =>
    handleSuccess(state, 'deleteAgentType', response.data),
  ),
  on(AgentTypesActions.DeleteAgentTypeAction.failure, (state, { error }) =>
    handleFailure(state, 'deleteAgentType', error),
  ),

  // Get single
  on(AgentTypesActions.GetAgentTypeAction.request, (state) =>
    handleRequest(state, 'selectedAgentType'),
  ),
  on(AgentTypesActions.GetAgentTypeAction.success, (state, { response }) =>
    handleSuccess(state, 'selectedAgentType', response.data),
  ),
  on(AgentTypesActions.GetAgentTypeAction.failure, (state, { error }) =>
    handleFailure(state, 'selectedAgentType', error),
  ),
);
